import React, { useEffect, useState } from 'react'
import { Button, Divider, Drawer, Flex, Radio, Space, Tag, Typography } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import { database } from '../../utils/firebase'
import TopBar from './TopBar'
import CommunicationButtons from './CommunicationButtons'

const { Title, Text, Link } = Typography

const LabTracking = () => {
  const [lab, setLab] = useState(null)
  const [patient, setPatient] = useState(null)
  const [statusDrawer, setStatusDrawer] = useState(false)
  const [status, setStatus] = useState('')
  const { chatID } = useParams()

  const navigate = useNavigate()
  const handleViewResults = () => {
    navigate(`/viewresults/${chatID}`)
  }
  const handleViewSOAPNotes = () => {
    navigate(`/soapnotes/${chatID}`)
  }
  const fetchLabDetails = (chatID) => {
    database.ref(`labTracking/${chatID}`).once('value', (snapshot) => {
      const response = snapshot.val()
      console.log('response', response)
      setLab(response)
      setStatus(response?.status) //
      console.log('status?')

    })
  }
  useEffect(() => {
    fetchLabDetails(chatID)

  }, [])
  const getTagColor = (status) => {
    let color
    switch (status) {
      case 'critical':
        color = 'red'
        break
      case 'normal':
        color = 'green'
        break
      case 'abnormal':
        color = 'yellow'
        break
      case 'undetermined':
        color = 'grey'
        break
      case 'pending':
        color = 'orange'
        break
      case 'awaiting':
        color = 'purple'
        break
      default:
        color = 'blue'
    }
    return color
  }

  useEffect(() => {

    if (lab?.patientID) {
      database.ref(`users/${lab.patientID}`).once('value', (snapshot) => {
        const response = snapshot.val()
        console.log('Patient', response)
        setPatient(response)

      })
    }
  }, [lab?.patientID])
  const handleStatusChange = (e) => {
    setStatus(e.target.value)
    setStatusDrawer(false)
    // Update the status in the database
    database.ref(`labTracking/${chatID}`).update({ status: e.target.value })
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <TopBar title="Lab Tracking" />
      <div style={{ flex: '1' }}>
        <Flex gap="small" style={{ padding: '8px' }}>
          <Text strong style={{ marginLeft: '10px' }}>
            {lab?.patientName}
          </Text>
          <Text>
            Diagnosis -{lab?.assessment}
          </Text>
        </Flex>
        <Divider style={{ margin: 0 }} />

        <CommunicationButtons chatID={chatID} status={status} />
        <Flex vertical gap="small" style={{ padding: '20px' }}>
          <Flex justify="space-between">
            <Text strong>Patient Name:</Text>
            <Text>{lab?.patientName}</Text>
          </Flex>
          <Flex justify="space-between">
            <Text strong>Diagnosis:</Text>
            <Text>{lab?.assessment}</Text>
          </Flex>

          <Flex justify="space-between">
            <Text strong>Encounter Date:</Text>
            <Text>{new Date(lab?.timestamp).toLocaleString()}</Text>
          </Flex>

          <Flex justify="space-between">
            <Text strong>Phone Number:</Text>
            <Link>{lab?.phoneNumber}</Link>
          </Flex>

          <Flex justify="space-between">
            <Text strong>Status:</Text>
            <Tag color={getTagColor(status)}>{status}</Tag>
          </Flex>

          <Flex justify="space-between">
            <Text strong>DOB:</Text>
            <Text strong>{patient?.DOB}</Text>
          </Flex>

          <Flex justify="space-between">
            <Text strong>Gender:</Text>
            <Text>{patient?.gender}</Text>
          </Flex>

          <Flex justify="space-between">
            <Text strong>State:</Text>
            <Text>{patient?.state}</Text>
          </Flex>

          <Flex justify="space-between">
            <Text strong>Health Card:</Text>
            <Text>{patient?.healthInsuranceCardNumber}</Text>
          </Flex>
        </Flex>
        <Divider />
        <Drawer
          open={statusDrawer}
          onClose={() => setStatusDrawer(false)}
          placement="bottom"
          footer={null}>

          <Flex vertical>
            <Radio.Group onChange={handleStatusChange} value={status}>
              <Space direction="vertical" justify="space-evenly">
                <Text strong>Status</Text>
                <Radio value="normal">Normal </Radio>
                <Radio value="critical">Critical</Radio>
                <Radio value="abnormal">Abnormal</Radio>
              </Space>
            </Radio.Group>
          </Flex>
        </Drawer>
      </div>
      <Divider />
      <Flex gap="middle" justify="center" style={{ marginTop: 'auto', paddingBottom: '16px' }}>
        <Button onClick={() => setStatusDrawer(true)} style={{ borderColor: '#DF7467', color: '#DF7467' }}>Change
          Status</Button>
        <Button onClick={handleViewSOAPNotes} style={{ borderColor: '#DF7467', color: '#DF7467' }}>Soap Notes</Button>
      </Flex>
      <Flex gap="small" justify="center" style={{ paddingBottom: '16px' }}>
        <Button onClick={handleViewResults} style={{ borderColor: '#DF7467', color: '#DF7467' }}>View Results</Button>
      </Flex>
    </div>
  )
}

export default LabTracking
